<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">מחיקת דוח</p>
    </header>
    <section class="modal-card-body">
      <p class="has-text-danger has-text-weight-bold">פעולה זו אינה הפיכה! הדוח יימחק לצמיתות.</p>
      <p class="mt-2">
        לאישור המחיקה, יש להזין את מספר הדוח:
        <strong>{{ reportNumber }}</strong>
      </p>
      <b-field label="מספר דוח לאישור" class="mt-4">
        <b-input v-model="confirmationInput" placeholder="הזן מספר דוח" />
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button
        type="is-danger"
        :disabled="confirmationInput !== String(reportNumber) || isLoading"
        :loading="isLoading"
        @click="onDelete"
      >מחק דוח</b-button>
      <b-button @click="$emit('close')">בטל</b-button>
    </footer>
  </div>
</template>

<script>
import ReportService from '@/services/ReportService';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'DialogDeleteReport',
  props: {
    reportId: {
      type: [Number, String],
      required: true,
    },
    reportNumber: {
      type: [Number, String],
      required: true,
    },
    onSuccess: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      confirmationInput: '',
      isLoading: false,
    };
  },
  methods: {
    onDelete() {
      this.isLoading = true;
      ReportService.deleteReport(this.reportId)
        .then(() => {
          Toast.open({
            type: 'is-success',
            message: 'הדוח נמחק בהצלחה!',
            duration: 4000,
          });
          this.$emit('close');
          if (this.onSuccess) {
            this.onSuccess();
          }
        })
        .catch((err) => {
          Toast.open({
            type: 'is-danger',
            message: (err.response && err.response.data && err.response.data.ErrorMessage) || 'קרתה תקלה, המחיקה לא התבצעה!',
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
